<template>
  <div class="signup__step signup__step--01">
    <div class="stepForm">
      <div class="content" >
        <div class="content__header">
          <h2 class="content__title">Dados de cadastro</h2>
          <p class="content__description">
            Informe seus <strong>dados de pessoa física</strong> para preencher
            o formulário abaixo.
          </p>
        </div>

        <div class="formLineBox formLineBox--02xs01">
          <fieldset
            class="formLine"
            :class="{
              active: iptNome,
              error: $v.iptNome.$error,
              focus: focus.iptNome
            }"
          >
            <div class="inputBox">
              <label for="iptNome">Nome *</label>
              <input
                type="text"
                name="iptNome"
                id="iptNome"
                v-model="iptNome"
                @focus="iptFocus('iptNome', $event)"
                @blur="iptBlur('iptNome', $event)"
                data-cy="personal-input-name"
              />
              <p class="errorText">{{ errors.iptNome }}</p>
            </div>
          </fieldset>

          <fieldset
            class="formLine"
            :class="{
              active: iptSobrenome,
              error: $v.iptSobrenome.$error,
              focus: focus.iptSobrenome
            }"
          >
            <div class="inputBox">
              <label for="iptSobrenome">Sobrenome *</label>
              <input
                type="text"
                name="iptSobrenome"
                id="iptSobrenome"
                v-model="iptSobrenome"
                @focus="iptFocus('iptSobrenome', $event)"
                @blur="iptBlur('iptSobrenome', $event)"
                data-cy="personal-input-surname"
              />
              <p class="errorText">{{ errors.iptSobrenome }}</p>
            </div>
          </fieldset>
        </div>

        <div class="formLineBox formLineBox--02xs01">
          <fieldset
            class="formLine"
            :class="{
              active: iptCPF,
              error: $v.iptCPF.$error,
              focus: focus.iptCPF
            }"
          >
            <div class="inputBox">
              <label for="iptCPF">CPF *</label>
              <input
                type="tel"
                name="iptCPF"
                id="iptCPF"
                v-model="iptCPF"
                v-mask="'999.999.999-99'"
                @focus="iptFocus('iptCPF', $event)"
                @blur="iptBlur('iptCPF', $event)"
                data-cy="personal-input-cpf"
              />
              <p class="errorText" v-html="errors.iptCPF"></p>
            </div>
          </fieldset>

          <fieldset
            class="formLine"
            :class="{
              active: iptDtNascimento,
              error: $v.iptDtNascimento.$error,
              focus: focus.iptDtNascimento
            }"
          >
            <div class="inputBox">
              <label for="iptDtNascimento">Data de Nascimento *</label>
              <input
                type="tel"
                name="iptDtNascimento"
                id="iptDtNascimento"
                v-mask="'99/99/9999'"
                v-model="iptDtNascimento"
                @focus="iptFocus('iptDtNascimento', $event)"
                @blur="iptBlur('iptDtNascimento', $event)"
                data-cy="personal-input-birthdate"
              />
              <p class="errorText">{{ errors.iptDtNascimento }}</p>
            </div>
          </fieldset>
        </div>

        <div class="formLineBox formLineBox--02xs01">
          <fieldset
            class="formLine"
            :class="{
              active: iptEmail,
              error: $v.iptEmail.$error,
              focus: focus.iptEmail
            }"
          >
            <div class="inputBox">
              <label for="iptEmail">E-mail *</label>
              <input
                type="text"
                name="iptEmail"
                id="iptEmail"
                maxlength="50"
                v-model="iptEmail"
                @focus="iptFocus('iptEmail', $event)"
                @blur="iptBlur('iptEmail', $event)"
                data-cy="personal-input-email"
              />
              <p class="errorText" v-html="errors.iptEmail"></p>
            </div>
          </fieldset>

          <fieldset
            class="formLine"
            :class="{
              active: iptCelular,
              error: $v.iptCelular.$error,
              focus: focus.iptCelular
            }"
          >
            <div class="inputBox">
              <label for="iptCelular">Celular *</label>
              <input
                type="tel"
                name="iptCelular"
                id="iptCelular"
                v-model="iptCelular"
                v-mask="'(99) 99999-9999'"
                @focus="iptFocus('iptCelular', $event)"
                @blur="iptBlur('iptCelular', $event)"
                data-cy="personal-input-phone"
              />
              <p class="errorText" v-html="errors.iptCelular"></p>
            </div>
          </fieldset>
        </div>

        <div class="password-container">
          <CreatePasswordInput
            inputLabel="Senha *"
            v-model="newPassword"
            :formError="$v.newPassword.$error"
            @input="$v.newPassword.$touch"
            ref="passwordInput"
            data-cy="personal-input-password"
            strengthField
          />
        </div>


        <div class="terms-container formLineBox">
          <fieldset class="terms-container__check checkLine">
            <div class="inputBox">
              <input
                type="checkbox"
                name="chkTermos"
                id="chkTermos"
                class="customCheck"
                :class="{ error: $v.chkTermos.$error }"
                v-model="chkTermos"
                data-cy="personal-checkbox-terms"
              />
              <label for="chkTermos">
                Concordo com os
                <a
                  href="/termos"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Termos de Uso
                </a> e
                <a
                  href="https://lwsa.tech/politicas/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Políticas de privacidade
                </a>
                *.
                </label>
            </div>
            <small class="formLineBox--warning">*Os campos marcados com asterisco são de preenchimento obrigatório</small>
          </fieldset>

          <button
            name="Avançar formulário"
            type="submit"
            class="terms-container__button button button--primary"
            @click="submit"
            data-cy="personal-button-submit"
          >
            avançar
          </button>
        </div>
      </div>

      <!-- error modal -->
      <transition name="fade">
        <modal-base
          v-if="$parent.showModal"
          title='Atenção!'
          class="lead-form__error-modal"
        >
          <template v-slot:close-icon>
            <svg @click.prevent='$parent.showModal = false' class='modal__close-icon'>
              <use xlink:href='/images/svg-symbols.svg#close' />
            </svg>
          </template>
          <template v-slot:content>
            <p style="text-align: center !important">
              {{ modalMessage }}
            </p>
          </template>
          <template v-slot:footer>
            <button class="button button--primary" @click.prevent="$parent.showModal = false">
              Tentar novamente
            </button>
          </template>
        </modal-base>
      </transition>
    </div>
  </div>
</template>

<script>
import recaptcha from "../../../../commons/js/ReCAPTCHAv3";
import {
  required,
  minLength,
  maxLength,
  email,
  sameAs
} from "vuelidate/lib/validators";

import AwesomeMask from "awesome-mask";

import cpf from "commons/js/validators/cpf";
import date from "commons/js/validators/date";
import name from "commons/js/validators/name";
import phoneMobile from "commons/js/validators/phoneMobile";
import birthDate from "commons/js/validators/birthDate";
import newPasswordRules from "commons/js/validators/newPasswordRules";
import Tooltip from "commons/js/components/atoms/Tooltip.vue";
import ModalBase from "commons/js/components/atoms/ModalBase.vue";

import CreatePasswordInput from "commons/js/components/atoms/CreatePasswordInput.vue";
import PasswordInput from "commons/js/components/atoms/PasswordInput.vue";

import {scrollToTop} from 'commons/js/utils/scroll.js';

export default {
  components: {
    ModalBase,
    "me-tooltip": Tooltip,
    CreatePasswordInput,
    PasswordInput
  },
  props: {
    leadInfo: {
      type: Object
    }
  },
  data() {
    return {
      newPassword: '',

      iptNome: "",
      iptSobrenome: "",
      iptNomeLoja: "",
      iptCelular: "",
      iptEmail: "",
      iptCPF: "",
      iptDtNascimento: "",
      chkTermos: false,
      modalMessage: "",
      errorMessages: {
        required: "Campo obrigatório! Não esqueça de preenchê-lo.",
        name: "Use apenas letras, sem caracteres especiais ou números",
        minLength: "Dado inválido! Verifique sua resposta.",
        maxLength: "Dado inválido! Verifique sua resposta.",
        email: "Endereço de e-mail inválido! Verifique sua resposta.",
        sameAsEmail: "Endereço de e-mail inválido! Verifique sua resposta.",
        cpf: "CPF inválido! Verifique sua resposta.",
        date: "Data inválida! Verifique sua resposta.",
        birthDate: "É necessário ter pelo menos 18 anos.",
        phoneFixed: "Telefone inválido! Verifique sua resposta.",
        phoneMobile: "Número de celular inválido! Verifique sua resposta.",
        sameAsPassword: "As senhas não são iguais. Tente novamente.",
        isUnique: "Este __field__ já está cadastrado ou é inválido. Gostaria de <a href='/login'>fazer login</a>?",
        genericError: "Ops! Ocorreu um erro no seu cadastro. Por favor, verifique suas informações.",
        csrfExpired: "A página expirou. Por favor, recarregue a tela e tente novamente.",
        manyAttempts: "Você fez muitas tentativas, tente novamente em alguns minutos."
      },
      errors: {
        iptNome: "",
        iptSobrenome: "",
        iptNomeLoja: "",
        iptCelular: "",
        iptEmail: "",
        iptCPF: "",
        iptDtNascimento: ""
      },
      focus: {
        iptNome: false,
        iptSobrenome: false,
        iptNomeLoja: false,
        iptCelular: false,
        iptEmail: false,
        iptCPF: false,
        iptDtNascimento: false,
      },
    };
  },

  directives: {
    mask: AwesomeMask
  },

  created() {
    if (this.leadInfo) {
      let splitedName = this.leadInfo.name.split(" ")
      this.iptNome = splitedName[0];
      this.iptSobrenome = splitedName.slice(1,splitedName.length).join(" ");
      this.iptEmail = this.leadInfo.email;
    }

    if (this.$parent.firstname) {
      this.iptNome = this.$parent.firstname;
    }
    if (this.$parent.lastname) {
      this.iptSobrenome = this.$parent.lastname;
    }
    if (this.$parent.email) {
      this.focus.iptEmail = true;
      this.iptEmail = this.$parent.email;
    }
  },

  mounted() {
    scrollToTop();
    setTimeout(this.$v.$reset, 0);
    setTimeout(() => {
      this.$el.querySelector(this.iptNome ? "#iptCPF" : "#iptNome").focus();
    }, 250);
    if(this.iptEmail) {
      this.$v.iptEmail.$touch();
    }
  },

  watch: {
    iptEmail(value) {
      this.iptEmail = this.removeAccents(value);
    }
  },

  methods: {
    removeAccents(value) {
      let r = value.toLowerCase();
      r = r.replace(new RegExp(/[àáâãäå]/g), "a");
      r = r.replace(new RegExp(/æ/g), "ae");
      r = r.replace(new RegExp(/ç/g), "c");
      r = r.replace(new RegExp(/[èéêë]/g), "e");
      r = r.replace(new RegExp(/[ìíîï]/g), "i");
      r = r.replace(new RegExp(/ñ/g), "n");
      r = r.replace(new RegExp(/[òóôõö]/g), "o");
      r = r.replace(new RegExp(/œ/g), "oe");
      r = r.replace(new RegExp(/[ùúûü]/g), "u");
      r = r.replace(new RegExp(/[ýÿ]/g), "y");
      r = r.replace(new RegExp(/[~^´'!]/g), "");
      r = r.replace(new RegExp(/\s+/g), "");
      return r;
    },
    iptFocus(ipt) {
      this.focus[ipt] = true;
    },
    iptBlur(ipt) {
      this.focus[ipt] = false;
      this.$v[ipt].$touch();
      this.updateErrorMessage(ipt);
    },
    updateErrorMessage(key) {
      let errorTypes = Object.keys(this.errorMessages);
      for (let i = 0; i < errorTypes.length; i++) {
        let errorType = errorTypes[i];
        if (
          this.$v[key].hasOwnProperty(errorType) &&
          !this.$v[key][errorType]
        ) {
          this.errors[key] = "";
          if (this.errorMessages.hasOwnProperty(errorType)) {
            this.errors[key] = String(this.errorMessages[errorType]).replace(
              /__field__/,
              String(key)
                .replace(/^ipt/, "")
                .replace(/Change$/, "")
            );
          }
          break;
        }
      }
    },
    registerUser() {
      this.$parent.loading = true;
      let data = {
        firstname: String(this.iptNome).trim(),
        lastname: String(this.iptSobrenome).trim(),
        company: String(this.iptNomeLoja).trim(),
        email: String(this.iptEmail).trim(),
        document: String(this.iptCPF).replace(/\D/g, ""),
        birthdate: String(this.iptDtNascimento)
          .split("/")
          .reverse()
          .join("-"),
        phone_mobile: String(this.iptCelular).replace(/\D/g, ""),
        password: this.newPassword,
        terms: this.chkTermos,
        commissioned: this.$parent.commissioned
          ? String(this.$parent.commissioned).trim()
          : "",
        coupon_signup: this.$parent.coupon_signup
          ? String(this.$parent.coupon_signup).trim()
          : "",
      };

      Object.keys(data).forEach(key => {
        if (!data[key]) delete data[key];
      });

      recaptcha('register', (token) => {
        data.recaptcha_token = token;

        axios
          .post("/api/v2/users", data)
          .then(response => {
            if (response.data && response.data.token) {
              window.axios.defaults.headers.common["Authorization"] =
                "Bearer " + response.data.token;
              this.$parent.id = response.data.id;
              this.$parent.phone = this.iptCelular;
              this.saveUserMail();
              this.$parent.next();
              scrollToTop();
            }
          })
          .catch((error) => {
            switch (error.response.status) {
              case 419:
                this.modalMessage = this.errorMessages.csrfExpired;
                break;
              case 429:
                this.modalMessage = this.errorMessages.manyAttempts;
                break;
              default:
                this.modalMessage = this.errorMessages.genericError;
            }
            this.$parent.showModal = true;
          })
          .finally(() => {
            this.$parent.loading = false;
          });
      });
    },
    submit() {
      scrollToTop();
      if (this.$v.$invalid) {
        this.$v.$touch();
        this.$refs.passwordInput.touch();

        let errorTypes = Object.keys(this.errorMessages);
        Object.keys(this.$v.$params).forEach(e => {
          for (let i = 0; i < errorTypes.length; i++) {
            let errorType = errorTypes[i];
            if (
              this.$v[e].hasOwnProperty(errorType) &&
              !this.$v[e][errorType]
            ) {
              this.errors[e] = "";
              if (this.errorMessages.hasOwnProperty(errorType)) {
                this.errors[e] = String(this.errorMessages[errorType]).replace(
                  /__field__/,
                  String(e)
                    .replace(/^ipt/, "")
                    .replace(/Change$/, "")
                );
              }
              break;
            }
          }
        });
        return;
      }
      this.registerUser();
    },

    saveUserMail() {
      localStorage.setItem('user-mail', String(this.iptEmail).trim());
    },

    isValidEmail(value) {
      const isValidEmail = email(value);
      const hasPlusSign = value.includes('+');

      if(!isValidEmail || hasPlusSign) {
        return false;
      }

      return true;
    }
  },

  validations: {
    iptNome: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(32),
      name
    },
    iptSobrenome: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(64),
      name
    },
    iptEmail: {
      required,

      email: function(value) {
        return this.isValidEmail(value);
      },

      isUnique(value) {
        if (!value) {
          return true;
        }

        if(!this.isValidEmail(value)) {
          return false;
        }

        return new Promise(resolve => {
          axios
            .get("/api/v2/validate/email/" + value)
            .then(response => {
              resolve(response.data);
            })
            .catch(error => {
              resolve(error.response.data || false);
            });
        });
      }
    },
    iptCPF: {
      required,
      cpf,
      isUnique(value) {
        if (!value) return true;
        value = String(value).replace(/\D/g, "");
        if (value.length !== 11) return false;
        return new Promise((resolve, reject) => {
          axios
            .get("/api/v2/validate/document/" + value)
            .then(response => {
              resolve(response.data);
            })
            .catch(() => {
              reject(false);
            });
        });
      }
    },
    iptDtNascimento: {
      required,
      date,
      birthDate
    },
    iptCelular: {
      required,
      phoneMobile,
      isUnique(value) {
        if (!value) return true;
        value = String(value).replace(/\D/g, "");
        if (value.length !== 11) return false;
        return new Promise((resolve, reject) => {
          axios
            .get("/api/v2/validate/phone/" + value)
            .then(response => {
              resolve(response.data);
            })
            .catch(() => {
              reject(false);
            });
        });
      }
    },
    newPassword: {
      required,
      newPasswordRules,
      minLength: minLength(12),
      maxLength: maxLength(64)
    },
    chkTermos: {
      sameAs: sameAs(() => true)
    }
  }
};
</script>

<style lang="stylus" scoped>
.password-container
  display grid
  grid-template-columns 1fr 1fr
  column-gap 60px

  @media screen and (max-width 800px)
    grid-template-columns 1fr
    column-gap 20px

.terms-container
  display flex
  flex-direction column
  gap 40px 0
  margin-top 20px

  @media screen and (min-width 767px)
    flex-direction row
    align-items center
    gap 0
    margin-top 40px

  &__check
    padding-top 0

  &__button
    margin-left auto
</style>
